import { render, staticRenderFns } from "./date-alert-banner.vue?vue&type=template&id=848bf9be&scoped=true&"
import script from "./date-alert-banner.vue?vue&type=script&lang=js&"
export * from "./date-alert-banner.vue?vue&type=script&lang=js&"
import style0 from "./date-alert-banner.vue?vue&type=style&index=0&id=848bf9be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "848bf9be",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})
